// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICustomPageCombineHsaSearchResponse,
} from '../models/index';
import {
    ICustomPageCombineHsaSearchResponseFromJSON,
    ICustomPageCombineHsaSearchResponseToJSON,
} from '../models/index';

export interface SearchCombineHsaRequest {
    searchValue?: string;
    employeeId?: number;
    ssn?: string;
    firstName?: string;
    lastName?: string;
    size?: number;
    page?: number;
}

/**
 * CombineHsaSearchControllerApi - interface
 * 
 * @export
 * @interface CombineHsaSearchControllerApiInterface
 */
export interface CombineHsaSearchControllerApiInterface {
    /**
     * 
     * @param {string} [searchValue] 
     * @param {number} [employeeId] 
     * @param {string} [ssn] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {number} [size] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CombineHsaSearchControllerApiInterface
     */
    searchCombineHsaRaw(requestParameters: SearchCombineHsaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageCombineHsaSearchResponse>>;

    /**
     */
    searchCombineHsa(requestParameters: SearchCombineHsaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageCombineHsaSearchResponse>;

}

/**
 * 
 */
export class CombineHsaSearchControllerApi extends runtime.BaseAPI implements CombineHsaSearchControllerApiInterface {

    /**
     */
    async searchCombineHsaRaw(requestParameters: SearchCombineHsaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageCombineHsaSearchResponse>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['ssn'] != null) {
            queryParameters['ssn'] = requestParameters['ssn'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/combine-hsa-search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageCombineHsaSearchResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchCombineHsa(requestParameters: SearchCombineHsaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageCombineHsaSearchResponse> {
        const response = await this.searchCombineHsaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
